import { PropsWithChildren } from 'react'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { queryClient } from '@shared/clients/http/ReactQuery'
import { ThemeProvider } from '@shared/components/Theme/contexts/ThemeContext'

import { AppAuthProvider } from '@modules/auth/contexts'

export function GlobalProvider({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools client={queryClient} />
      <ThemeProvider>
        <AppAuthProvider>{children}</AppAuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
